import React, { useState, useEffect } from 'react';
import { experiences as allExperiences } from '../data';
import './Experience.css';

const SessionShowcase = ({ exp }) => (
  <div className="session-showcase reveal">
    <div className="session-content">
      <div className="session-tag">{exp.organization.toUpperCase()}</div>
      <h3 className="session-title">{exp.role}</h3>
      <div className="session-date">{exp.date}</div>
      <p className="session-desc">{exp.description}</p>
    </div>
    {exp.image && (
      <div className="session-img-wrap">
        <img src={exp.image} alt={exp.role} className="session-img" />
      </div>
    )}
  </div>
);

const ExperienceItem = ({ exp, index }) => (
  <article 
    className={`exp-item ${index === 0 ? 'current-role-item' : ''}`}
    itemScope 
    itemType="https://schema.org/WorkPlace"
  >
    <div className="exp-sidebar">
      <div className="exp-sidebar-header">
        <div className="exp-num">{String(index + 1).padStart(2, '0')}</div>
        {exp.logo && (
          <img 
            src={exp.logo} 
            alt={`${exp.organization} logo`} 
            className="exp-logo" 
            width="52" 
            height="52" 
            loading="lazy" 
          />
        )}
      </div>
      <div>
        <div className="exp-co" itemProp="name">{exp.organization.toUpperCase()}</div>
        <div className="exp-period">{exp.date}</div>
        {exp.location && (
          <div className="exp-location" itemProp="address">
            📍 {exp.location}
          </div>
        )}
        <div className="exp-meta-tags">
          <span className={`exp-type-tag ${index === 0 ? 'tag-current' : ''}`}>
            {exp.type === 'Professional Experience' ? (index === 0 ? 'Current Role' : 'Completed') : exp.type}
          </span>
          {exp.employmentType && (
            <span className="exp-emp-tag">{exp.employmentType}</span>
          )}
        </div>
      </div>
    </div>
    <div className="exp-body">
      <h3 className="exp-role-title" itemProp="jobTitle">
        {exp.role}
        {index === 0 && <span className="current-badge">● Present</span>}
      </h3>
      {exp.image && (
        <img src={exp.image} alt={exp.role} className="exp-img" />
      )}
      <ul className="exp-blist">
        {exp.description.split('. ').map((sentence, i) => {
          if (!sentence.trim()) return null;
          let text = sentence.trim();
          if (!text.endsWith('.')) text += '.';
          return <li key={i}>{text}</li>;
        })}
      </ul>
    </div>
  </article>
);

const Experience = () => {
  const [experiences, setExperiences] = useState([]);

  useEffect(() => {
    setExperiences(allExperiences);
  }, []);

  const profExp = experiences.filter(e => e.type === 'Professional Experience');
  const volExp = experiences.filter(e => e.type === 'Volunteering & Leadership');
  const sessions = experiences.filter(e => e.type === 'Sessions & Talks');

  return (
    <section id="experience" className="sec">
      <div className="sec-inner">
        <div className="sec-label">02 — Experience</div>
        <h2 className="sec-title">Where I shipped<br /><em>production code</em></h2>

        <div className="exp-wrapper reveal">
          {profExp.map((exp, index) => (
            <ExperienceItem key={exp._id || index} exp={exp} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
